import styled from '@emotion/styled';
import React from 'react';
import { FlexGroup, FlexItem, ResponsiveContainer, Text } from '.';
import { useTectonTheme } from '@lithos';
import { LithosComponent } from './LithosComponent';

interface NavigationGroupProps {
  label?: string;
  beforeItems?: React.ReactNode[];
  items?: React.ReactNode[];
}

const Wrapper = styled.div`
  overflow-y: hidden;
  max-height: 100%;

  .full-size {
    display: block;
  }

  .compressed {
    display: none;
  }
  .navigation-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @container (max-width: ${({ theme }) => theme.v1.navigationBreakpoints.s}px) {
    .navigation-label {
      display: none;
    }

    .full-size {
      display: none;
    }

    .compressed {
      display: block;
    }
  }
`;

const ItemsWrapper = styled.div`
  overflow: hidden;
  height: 100%;
`;

const LabelWrapper = styled.div`
  padding: 0px ${({ theme }) => theme.v1.size['2']}px;
`;

const NavigationGroup: LithosComponent<NavigationGroupProps> = ({
  label,
  beforeItems,
  items,
  testId = 'navigation-group',
}) => {
  const { theme } = useTectonTheme();

  return (
    <ResponsiveContainer data-testid={testId}>
      <Wrapper>
        <FlexItem grow={'0'} shrink="0">
          {label && (
            <LabelWrapper className="navigation-label">
              <Text size="xs" color={theme.v1.colors.text.subduedText}>
                {label.toUpperCase()}
              </Text>
            </LabelWrapper>
          )}
        </FlexItem>
        <ItemsWrapper>
          {beforeItems && (
            <FlexItem grow={'0'} shrink="0">
              {beforeItems}
            </FlexItem>
          )}
          <FlexItem grow={'0'} shrink="0">
            <FlexGroup direction="column" padding="0" gapSize="1" justifyContent="center">
              {items}
            </FlexGroup>
          </FlexItem>
        </ItemsWrapper>
      </Wrapper>
    </ResponsiveContainer>
  );
};

export default NavigationGroup;
